//redux
import { useSelector } from "react-redux"

// *************************************************************
//     Misc

export function useContribuyentesError() {
  return useSelector(state => state.Contribuyentes.context.error)
}

export function useContribuyentesIsLoading() {
  return useSelector(state => state.Contribuyentes.context.loading)
}

export function useContribuyentesIsLoadingContribuyentes() {
  return useSelector(
    state => state.Contribuyentes.context.loadingContribuyentes
  )
}

export function useContribuyentesLista() {
  return useSelector(state => state.Contribuyentes.context.listaContribuyentes)
}

export function useContribuyentesOptions(elige = false) {
  const options = useSelector(
    state => state.Contribuyentes.context.optionsContribuyentes
  )
  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    options.unshift({
      value: -1, // Puedes usar un valor especial que indique que es una selección predeterminada
      label: "Elige", // El texto que quieras mostrar en la opción por defecto
    })
  }
  return options
}

export function useContribuyentesoContribuyente() {
  return useSelector(state => state.Contribuyentes.context.oContribuyente)
}

export function useContribuyentesMensajeExito() {
  return useSelector(state => state.Contribuyentes.context.mensajeExito)
}
